// Keyboard hints built from the player's bindings, for the pause menus and the settings.
import type { GameAction } from '../devices/input.js';
import { keysFor } from '../devices/controls.js';
import { esc } from './dom.js';
import { t } from '../i18n/index.js';

const names = () => ({ space: t.settings.keys.space, esc: t.settings.keys.esc });

/** `<kbd>` of every key bound to the actions, or an em dash when none is. */
export function kbd(...actions: GameAction[]): string {
  const keys = actions.flatMap(a => keysFor(a, names()));
  return keys.length ? keys.map(k => `<kbd>${esc(k)}</kbd>`).join(' ') : '—';
}
